<template>
  <component
    :is="component || variant"
    :class="[$attrs.class, computedClassList]"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
type TagVariant = keyof typeof tags;

const tags = {
  h1: 'text-primary text-4xl font-heading font-medium',
  h2: 'text-primary text-3xl font-bold',
  h3: 'text-primary text-2xl font-bold',
  h4: 'text-primary text-xl font-bold',
  h5: 'text-primary text-lg font-bold',
  h6: 'text-primary text-base font-bold',
  p: 'text-secondary text-base font-normal',
  span: 'text-sm font-normal',
  div: 'text-base font-normal',
  a: 'text-secondary font-normal',
  label: 'text-secondary text-base font-normal',
  li: 'text-base font-normal',
} as const;

const props = defineProps<{
  /**
   * Controls the style of the typography based on predefined variants.
   */
  variant: TagVariant;

  /**
   * Optional HTML tag to override the default tag defined by the variant.
   * If not provided, the tag matches the variant.
   */
  component?: string;
}>();

const computedClassList = computed(() => {
  return tags[props.variant] || tags.p;
});

defineOptions({
  inheritAttrs: false, // Prevent automatic merging of $attrs into root; we merge manually
});
</script>
